import { usePaymentContext } from '@/context-state/PaymentContext.jsx'
import { toggleAppBanner } from '@/hooks/useAppBanner.jsx'

// Guard for a Free-tier feature fence, enforced client-side.
//
// `available` reflects current access for the entitlement key (Free defaults come
// from consts/freeTierEntitlements.js via PaymentContext; paid tiers get full
// access). `enforce()` is meant to wrap an action handler: it shows the shared
// AppBanner and returns true when the action must be blocked, so callers can
// early-return. When access is allowed it does nothing and returns false.
//
//   const { available, enforce } = useFreeTierFence(EntitlementsKeys.VIEWS_MANAGE, 'free-views-limit', 'views_create')
//   const handleCreate = () => {
//       if (enforce()) return
//       ...open dialog
//   }
export const useFreeTierFence = (entitlementKey, bannerType, source) => {
    const { checkEntitlementAvailable } = usePaymentContext()
    const { available } = checkEntitlementAvailable(entitlementKey)

    const enforce = () => {
        if (available) {
            return false
        }
        toggleAppBanner(bannerType, source)
        return true
    }

    return { available, enforce }
}
